module.exports = __webpack_public_path__ + "img/2500_YR_2022_Background.722d4c6c.png";